"use strict";

class PropertyCreateController {

    constructor($window, $element, Upload, SSHttpService, SSUtilService, SSAlertService, OTPService, SSConfigService, SSAwsService, SSUserService, $timeout) {
        const self = this;

        self.$window = $window;
        self.$element = $element;
        self.$timeout = $timeout;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.propertyParams = {};
        self.propertyErrors = {};

        self.$timeout(function() { 
            $("select.dashboard-select").niceSelect('update'); 
        });
    }

    submitProject() {
        const self = this;

        self.propertyErrors = {};

        // Validate Required Data
        if (!self.SSUtilService.validateForm(self, 'ctrl', self.$element)) {
            self.SSAlertService.danger('Invalid Data!', 'Please fill in the required information.');
            return;
        }

        self.OTPService.getVerified(function (data) {
            self._submitProject(data);
        }, self.OTPService.TYPE_SESSION_2FA);
    }

    _submitProject() {
        const self = this;

        let params = self.propertyParams;

        let url = 'sec/developer/properties/create';

        self.propertyErrors = {};

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }

                jQuery.each(response.data, function (key) {
                    try {
                        self.propertyErrors[key] = response.data[key][0];
                    } catch (ex) {
                    }
                });

                return;
            }

            self.SSAlertService.success('Success!', 'New project created successfully.');

            // Update 'role_permissions' in local storage
            self.updateRolePermissions();

            self.cancelEditing();
        });
    }

    cancelEditing() {
        const self = this;

        self.$window.location = '/developer/properties';
    }

    updateRolePermissions(){
        const self = this;

        let url = 'sec/me';
        let params = {
            include: 'role_permissions'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Update 'role_permissions' in local storage
            self.SSUserService.clearRolePermissions();
            self.SSUserService.setRolePermissions(response.data.role_permissions);
        });
    }

    // Import

    importProperty() {
        const self = this;

        if (!self.importParams.propertyExcelFile) {
            return;
        }

        self.OTPService.getVerified(function (data) {
            self.uploadPropertyExcel(self.importParams.propertyExcelFile);
        }, self.OTPService.TYPE_SESSION_2FA);
    }

    uploadPropertyExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/properties/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 404) {
                    self.SSAlertService.danger('Invalid data format!', 'Please make sure you are using the correct file format.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }
            self.SSAlertService.success('Success!', 'Data file parsed successfully.');

            self.importData = response.data;

            if (self.importParams.propertyAssetFiles && self.importParams.propertyAssetFiles.length) {
                self.uploadPropertyFile(self.importParams.propertyAssetFiles);
            } else {
                self._importProperty();
            }

        }, function (response) {
            self.progressUploadingFiles = false;

            if (response.code == 404) {
                self.SSAlertService.danger('Invalid data format!', 'Please make sure you are using the correct file format.');
            } else {
                self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
            }
        }, function (evt) {
        });
    }

    uploadPropertyFile(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importProperty();
                    }
                });
            });
        });
    }

    _importProperty() {
        const self = this;

        let importUrl = 'sec/developer/import/properties';
        let params = {
            properties: self.importData.properties,
            assets: self.assets,
            stacks: self.importData.stacks
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Go to projects page
            self.cancelEditing();
        });
    }

    // Import

}

PropertyCreateController.$inject = ['$window', '$element', 'Upload', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'OTPService', 'SSConfigService', 'SSAwsService', 'SSUserService', '$timeout'];
app.controller('PropertyCreateController', PropertyCreateController);

